import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'crg-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  basePath = '';
  constructor(public authServc: AuthenticationService) {
    this.basePath = environment.apiBase;
  }

  ngOnInit() {
  }

}
